import "../scss/style.scss";

import { accordion } from "./modules/accordion";
import { tabs } from "./modules/tabs";
import { overlayMenu } from "./modules/overlay-menu";
import { pdfLinks } from "./modules/pdf-links";
import { dropdown } from "./modules/dropdown";
import { popup } from "./modules/popup";
import { mainMenuExtraMarkup } from "./modules/main-menu-extra-markup";
import { scrollList } from "./modules/scroll-list";
import { videoLazyLoad } from "./modules/video-lazy-load";
import { pageNavigation } from "./modules/page-navigation";

mainMenuExtraMarkup();

overlayMenu();

dropdown();

pdfLinks();

accordion();

tabs();

popup();

scrollList();

videoLazyLoad();

pageNavigation();
